export function formatBytes(n) {
  if (n == null || Number.isNaN(n)) return null
  if (n < 1024) return `${n} B`
  const u = ['KB', 'MB', 'GB']
  let i = -1
  let v = n
  do {
    v /= 1024
    i += 1
  } while (v >= 1024 && i < u.length - 1)
  return `${v < 10 ? v.toFixed(1) : Math.round(v)} ${u[i]}`
}

export function docKindFromName(name) {
  const lower = (name || '').toLowerCase()
  if (/^https?:\/\//i.test(name.trim())) return 'url'
  if (lower.endsWith('.pdf')) return 'pdf'
  if (lower.endsWith('.txt') || lower.endsWith('.md')) return 'txt'
  if (lower.endsWith('.docx') || lower.endsWith('.doc')) return 'docx'
  if (lower.endsWith('.csv')) return 'csv'
  if (/\.(png|jpe?g|gif|webp|heic|heif)$/i.test(lower)) return 'image'
  return 'other'
}

/** Map legacy emoji status strings to StatusPill variants. */
export function statusMessageVariant(message) {
  if (!message) return null
  if (message.includes('✅')) return 'success'
  if (message.includes('❌')) return 'error'
  if (message.includes('⚠️') || message.includes('🔑')) return 'warning'
  return 'info'
}

const STATUS_MESSAGE_EMOJI = ['✅', '❌', '⚠️', '🔑', '🔗', '🔄', '📥', '🔍']

export function statusMessageText(message) {
  if (!message) return ''
  let text = message
  for (const emoji of STATUS_MESSAGE_EMOJI) {
    text = text.split(emoji).join('')
  }
  return text.replace(/\s+/g, ' ').trim()
}

export const DOC_ICON_MAP = {
  pdf: ['fa-file-pdf', 'doc-icon-pdf'],
  txt: ['fa-file-lines', 'doc-icon-txt'],
  url: ['fa-link', 'doc-icon-web'],
  docx: ['fa-file-word', 'doc-icon-docx'],
  csv: ['fa-file-csv', 'doc-icon-csv'],
  image: ['fa-file-image', 'doc-icon-img'],
  other: ['fa-file', 'doc-icon-other'],
}
